/**
 * Normalizes a file path by removing leading slashes.
 * This is necessary because path.join() treats leading slashes as absolute paths.
 *
 * @param filePath - The file path to normalize
 * @returns The normalized path without leading slash
 *
 * @example
 * normalizeRelativePath("/config/routes.json") // => "config/routes.json"
 * normalizeRelativePath("config/routes.json")  // => "config/routes.json"
 */
export function normalizeRelativePath(filePath: string): string {
  return filePath.startsWith("/") ? filePath.slice(1) : filePath;
}

/**
 * Normalizes a path for consistent display (always start with /)
 *
 * @param filePath - The file path to normalize
 * @returns The normalized path with leading slash
 */
export function normalizeDisplayPath(filePath: string): string {
  return filePath.startsWith("/") ? filePath : `/${filePath}`;
}
